<template>
  <div :style="maxHeight" style="overflow-y: auto;overflow-x: hidden">
    <el-row style="height: 90%;margin-top: 5px">
        <div class="title">
<!--          <span>{{ '不良项目占比' }}</span>-->
          <div class="space-between">
            <el-date-picker v-model="pieDate.year" @change="getChart" format="YYYY 年" value-format="YYYY"
                            clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px"
                            size="small"/>
            <el-select v-model="pieDate.type" @change="getChart" size="small" clearable placeholder="类型"
                       style="width: 90px;margin-right: 10px">
              <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="pieDate.field" @change="getChart" size="small"
                       style="width: 90px;margin-right: 10px">
              <el-option
                  v-for="item in fieldNames"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-loading="loading" element-loading-text="数据加载中" style="width: 100%;height: 90%"
             id="pie"/>
    </el-row>

  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "MktHomePage",
  props: ['parentData'],
  data(){
    return{
      maxHeight:'',
      activeName:'first',
      infoLoading:false,
      dataInfo:{},
      infoDialog:false,
      dialogVisible:false,
      loading:false,
      dialogItem:{
        title:'',
        width:'30%'
      },
      chartData:{},
      dayBad:{
        dateDay:this.getDateFormat(),
      },
      pieDate:{
        // year:this.$common.getCurrentYearByMonth().toString(),
        year:'',
        // month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        type:'',
        field:'count',
      },
      types:[
        {value:'客户',label:'客户'},
        {value:'合作伙伴',label:'合作伙伴'},
        {value:'员工',label:'员工'},
        {value:'其他',label:'其他'}
      ],
      fieldNames:[
        {value:'count',label:'数量'},
        {value:'price',label:'价格'}
      ],
      suppliers:[],
      supplierBad:{
        supplier:'',
        year:this.$common.getCurrentYearByMonth().toString(),
      },

      /*物件别不良推移*/
      option: {
        type:'wujian_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            axisLabel: {
              formatter: function (value){
                return value.toFixed(0)
              }
            }
          }
        ],
        series: [

        ],
        dataZoom:[
          {
            start: 0,
            end: 100,
            type: 'slider',
            show: true,
            // xAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            startValue: null, // 初始显示值
            endValue: null, // 结束显示值
            height: 15,//组件高度
            left: '5%', //左边的距离
            right: '4%',//右边的距离
            borderRadius: 5,
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: true,//即拖拽时候是否显示详细数值信息 默认true
            realtime: false, //是否实时更新
            filterMode: 'filter',
          },
          //下面这个属性是里面拖到
          {
            type: 'inside',
            show: true,
            // xAxisIndex: [0],
            start: 1,//默认为1
            end: 100,//默认为100
          },
        ]
      },
      wuJianChartLoading:false,
      wuJianTarget:0,
    }
  },
  methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight - 160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },

    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },

    renderAllEcharts(){
      this.getChart()
    },

    async getChart() {
      this.loading = true
      let {data: res} = await this.$axios.post('mkt/Charts/customerCareChart',this.pieDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
      }else {
        if (res.data) {
          this.option.xAxis[0].data = res.data.xAxis
          this.option.series = res.data.series
        }
      }
      if (this.pieDate.field === 'count'){
        this.option.yAxis[0].name = '数量'
      }else {
        this.option.yAxis[0].name = '价格'
      }
      this.renderEcharts('pie',this.option)

      this.wuJianChartLoading = false
    },
  },

  created() {

  },

  beforeMount() {

  },

  mounted() {
    this.renderAllEcharts()
  }
}
</script>

<style scoped>
.topContainer{
  display: flex;
  flex-direction: row;
}

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}

.asideContainer{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.wujian_size{
  width: 940px;
  height: 200px
}

.chartSize{
  width: 470px;
  height: 190px
}

.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  margin-left: 40px;
}

.summary{
  height: 190px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.messageCard{
  width: 100px;
  height: 65px;
  background-color:whitesmoke;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

margin-right{
  margin-right: 5px;
}

.message{
  color: whitesmoke;
  border-radius: 5px;
}

</style>